const env = {
  // API_URL: 'http://503b-181-134-13-195.ngrok.io/', // ngrok
  // API_URL: 'http://localhost:1337/', // Dev
  API_URL:'https://apintranet.emilan.co/' // Prod
}

export default env